export default "__VITE_ASSET__DaWsEjX8__"